import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { PhoneCall, CalendarCheck, Mail, X } from "lucide-react";
import RequestCallbackModal from "@/components/RequestCallbackModal";

export default function FloatingContact() {
  const [open, setOpen] = useState(false);
  const [callbackOpen, setCallbackOpen] = useState(false);

  useEffect(() => {
    const handler = () => setCallbackOpen(true);
    window.addEventListener("open-callback", handler);
    return () => window.removeEventListener("open-callback", handler);
  }, []);

  return (
    <>
      {open && (
        <div data-testid="floating-contact-menu" className="fixed bottom-[168px] right-5 z-50 w-60 bg-white border border-slate-200 shadow-[0_20px_60px_-15px_rgba(41,50,74,0.4)] overflow-hidden">
          <div className="bg-gradient-to-r from-[#29324A] to-[#5A3A8B] px-4 py-3 text-white text-[11px] font-bold tracking-[0.16em] uppercase">
            How can we help?
          </div>
          <Link to="/book-consultation" data-testid="floating-book-btn" onClick={() => setOpen(false)}
            className="flex items-center gap-3 px-4 py-3.5 text-[13px] font-semibold text-[#29324A] hover:bg-[#F8F4FB] transition-colors border-b border-slate-100">
            <CalendarCheck className="h-4 w-4 text-[#C43A89]" /> Book a Consultation
          </Link>
          <button type="button" data-testid="floating-callback-btn" onClick={() => { setCallbackOpen(true); setOpen(false); }}
            className="w-full flex items-center gap-3 px-4 py-3.5 text-[13px] font-semibold text-[#29324A] hover:bg-[#F8F4FB] transition-colors border-b border-slate-100 text-left">
            <PhoneCall className="h-4 w-4 text-[#C43A89]" /> Request a Callback
          </button>
          <a href="mailto:yasmin@studynet.com.au" data-testid="floating-email-btn" onClick={() => setOpen(false)}
            className="flex items-center gap-3 px-4 py-3.5 text-[13px] font-semibold text-[#29324A] hover:bg-[#F8F4FB] transition-colors">
            <Mail className="h-4 w-4 text-[#C43A89]" /> Email Us
          </a>
        </div>
      )}
      <button
        type="button"
        data-testid="floating-contact-btn"
        aria-label="Contact options"
        onClick={() => setOpen((o) => !o)}
        className="fixed bottom-[92px] right-5 z-50 h-12 w-12 flex items-center justify-center bg-[#29324A] hover:bg-[#29324A] text-white rounded-full shadow-[0_12px_35px_-8px_rgba(41,50,74,0.55)] transition-all hover:-translate-y-0.5"
      >
        {open ? <X className="h-5 w-5" /> : <PhoneCall className="h-5 w-5" />}
      </button>
      <RequestCallbackModal open={callbackOpen} onClose={() => setCallbackOpen(false)} />
    </>
  );
}
